import {getDataWithPromise, Globals, handleAjaxError } from "./BaseDataFns";

export const getOutcomePayments = ( year_id, onComplete ) =>
{
    const url = Globals.APIFolder + "/outcomes/year/" + year_id + '?group_by=school'

    getDataWithPromise ( url, 'GET', {} )
    .then (response =>
    {
        onComplete (response) ;
    })
    .catch( (jqXHR, textStatus, error) =>
    {
        handleAjaxError( jqXHR, textStatus, error) ;
    });
}

export const getOutcomesForApproval = ( year_id, onComplete ) =>
{
    const url = Globals.APIFolder + "/outcomes/year/" + year_id ;

    getDataWithPromise ( url, 'GET', {} )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const actionPayment = ( school_outcome_id, data, onComplete) =>
{
    const url = Globals.APIFolder + "/outcomes/payments/" + school_outcome_id ;

    getDataWithPromise ( url, 'POST', data )
        .then (response =>
        {
            onComplete (response) ;
        })
        .catch( (jqXHR, textStatus, error) =>
        {
            handleAjaxError( jqXHR, textStatus, error) ;
        });
}

export const updateOutcome = ( child_id, cpp_id, data, authToken, onComplete) =>
{
   const url = Globals.APIFolder + '/children/' + child_id + '/outcomes/' + cpp_id;

   getDataWithPromise ( url, 'PUT', data , authToken )
      .then (response =>
      {
         onComplete (response) ;
      })
      .catch( (jqXHR, textStatus, error) =>
      {
         handleAjaxError( jqXHR, textStatus, error) ;
      });
}

export const createOutcome = ( child_id, data, authToken, onComplete) =>
{
   const url = Globals.APIFolder + '/children/' + child_id + '/outcomes' ;

   getDataWithPromise ( url, 'POST', data , authToken )
      .then (response =>
      {
         onComplete (response) ;
      })
      .catch( (jqXHR, textStatus, error) =>
      {
         handleAjaxError( jqXHR, textStatus, error) ;
      });
}

export const deleteOutcome = ( child_id, cpp_id, authToken, onComplete) =>
{
   const url = Globals.APIFolder + '/children/' + child_id + '/outcomes/' + cpp_id;

   getDataWithPromise ( url, 'DELETE', {} , authToken )
      .then (response =>
      {
         onComplete (response) ;
      })
      .catch( (jqXHR, textStatus, error) =>
      {
         handleAjaxError( jqXHR, textStatus, error) ;
      });
}

export const getOutcomeTerms = ( onComplete ) =>
{
    const url = Globals.APIFolder + "/outcomes/term/all";

    getDataWithPromise ( url, 'GET', {} )
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}

export const getOutcomeSchedulingStatus = ( onComplete ) =>
{
    const url = Globals.APIFolder + "/outcomes/year/status";

    getDataWithPromise ( url, 'GET', {} )
       .then (response =>
       {
           onComplete (response) ;
       })
       .catch( (jqXHR, textStatus, error) =>
       {
           handleAjaxError( jqXHR, textStatus, error) ;
       });
}

export const getChildOutcomes = ( child_id, ofr_id, authToken, onComplete ) =>
{
   const url = Globals.APIFolder + '/children/' + child_id + '/outcomes?ofr_id=' + ofr_id + '&include-history&include-ofr';

   getDataWithPromise ( url, 'GET', {}, authToken )
      .then (response =>
      {
         onComplete (response) ;
      })
      .catch( (jqXHR, textStatus, error) =>
      {
         handleAjaxError( jqXHR, textStatus, error) ;
      });
}

export const getOutcomeRequestsForTerm = ( term_id, year_group_id, onComplete ) =>
{
   const url = Globals.APIFolder + '/statistics/outcomerequests/year/' + term_id + '?group_id=' + year_group_id ;

   getDataWithPromise ( url, 'GET', {})
      .then (response =>
      {
         onComplete (response) ;
      })
      .catch( (jqXHR, textStatus, error) =>
      {
         handleAjaxError( jqXHR, textStatus, error) ;
      });
}


